module.exports = __webpack_public_path__ + "ClientApp/content/BlockRichResources/Roger-UngarDumont-NJ.jpg";